export const CONTEXT = {
  important: 'important',
  info: 'info',
  light: 'light',
  invalid: 'invalid',
  warning: 'warning',
  valid: 'valid'
};